import { atom } from "recoil";
import DiaryEntry from "../interfaces/DiaryEntry";

const diaryState = atom<DiaryEntry[]>({
  key: "diaryState",
  default: [],
});

export default diaryState;
